// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Hot & Cold Switch Panel Component CSS Module
 * Optimized for instant view switching performance
 */
.HpErtGOAC8ijJpZZN9UR {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 0;
}
.HpErtGOAC8ijJpZZN9UR[data-view='single'] {
  position: sticky;
  top: 0;
  pointer-events: none;
}
.HpErtGOAC8ijJpZZN9UR[data-view='single'] > * {
  pointer-events: auto;
}
.HpErtGOAC8ijJpZZN9UR[data-view='single']::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
  left: 0;
  height: 100px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 8.45%, rgba(0, 0, 0, 0) 87.86%);
  pointer-events: none;
}
.jsEBpyx_VN8vMD7AgNFf {
  background: #0f0103cc;
  box-shadow: 0px 0px 7px 0px #ba2002;
}
.DlWN5H0rXvwLOpe1P5Jz {
  background: #0e1729cc;
  box-shadow: 0px 0px 7px 0px #006ae3;
}
.AlMyca9NXerFcGMpp3D1 {
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  min-width: unset;
  min-height: unset;
  border: none;
  border-radius: 50%;
  backdrop-filter: blur(3px);
  transition: all 0.3s ease;
}
.RhLavjo7yztWEqfGClI8 {
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 24px;
  width: 408px;
  height: auto;
  padding: 8.5px 42px 8.5px 15px;
  border: none;
  border-radius: 10px;
  backdrop-filter: blur(3px);
  animation: a0OJuj9x3FE1cXZbPkBQ 0.15s ease-out;
}
@keyframes a0OJuj9x3FE1cXZbPkBQ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.hMRJaoB2BtYvhXReHoj_ {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  min-width: unset;
  min-height: unset;
  background: transparent;
  border: none;
}
.al5117oeQwui7nPoVz4t {
  display: block;
  color: #ffffff;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.18px;
}
.al5117oeQwui7nPoVz4t b {
  font-weight: 700;
}
@media (max-width: 1025px) {
  .HpErtGOAC8ijJpZZN9UR {
    padding: 20px 0;
  }
  .AlMyca9NXerFcGMpp3D1 {
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
  }
  .AlMyca9NXerFcGMpp3D1 svg {
    width: 6px;
    height: 16px;
  }
  .RhLavjo7yztWEqfGClI8 {
    top: 8px;
    right: 8px;
    width: 275px;
    padding: 5.5px 28px 5.5px 10px;
  }
  .hMRJaoB2BtYvhXReHoj_ {
    width: 28px;
    height: 28px;
  }
  .hMRJaoB2BtYvhXReHoj_ svg {
    width: 15px;
    height: 15px;
  }
  .al5117oeQwui7nPoVz4t {
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 0.12px;
  }
}
@media (max-width: 290px) {
  .RhLavjo7yztWEqfGClI8 {
    left: 8px;
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/hotCold/components/HotColdSwitchPanel/HotColdSwitchPanel.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,sFAAsF;EACtF,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,8CAAiC;AACnC;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":["/**\n * Hot & Cold Switch Panel Component CSS Module\n * Optimized for instant view switching performance\n */\n.toggleRow {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 30px 0;\n}\n.toggleRow[data-view='single'] {\n  position: sticky;\n  top: 0;\n  pointer-events: none;\n}\n.toggleRow[data-view='single'] > * {\n  pointer-events: auto;\n}\n.toggleRow[data-view='single']::before {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.7) 8.45%, rgba(0, 0, 0, 0) 87.86%);\n  pointer-events: none;\n}\n.infoThemeHot {\n  background: #0f0103cc;\n  box-shadow: 0px 0px 7px 0px #ba2002;\n}\n.infoThemeCold {\n  background: #0e1729cc;\n  box-shadow: 0px 0px 7px 0px #006ae3;\n}\n.infoButton {\n  position: absolute;\n  top: 24px;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  min-width: unset;\n  min-height: unset;\n  border: none;\n  border-radius: 50%;\n  backdrop-filter: blur(3px);\n  transition: all 0.3s ease;\n}\n.infoContainer {\n  position: absolute;\n  z-index: 2;\n  top: 24px;\n  right: 24px;\n  width: 408px;\n  height: auto;\n  padding: 8.5px 42px 8.5px 15px;\n  border: none;\n  border-radius: 10px;\n  backdrop-filter: blur(3px);\n  animation: scaleIn 0.15s ease-out;\n}\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.closeButton {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  min-width: unset;\n  min-height: unset;\n  background: transparent;\n  border: none;\n}\n.infoText {\n  display: block;\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.18px;\n}\n.infoText b {\n  font-weight: 700;\n}\n@media (max-width: 1025px) {\n  .toggleRow {\n    padding: 20px 0;\n  }\n  .infoButton {\n    top: 8px;\n    right: 8px;\n    width: 28px;\n    height: 28px;\n  }\n  .infoButton svg {\n    width: 6px;\n    height: 16px;\n  }\n  .infoContainer {\n    top: 8px;\n    right: 8px;\n    width: 275px;\n    padding: 5.5px 28px 5.5px 10px;\n  }\n  .closeButton {\n    width: 28px;\n    height: 28px;\n  }\n  .closeButton svg {\n    width: 15px;\n    height: 15px;\n  }\n  .infoText {\n    font-size: 15px;\n    line-height: 19px;\n    letter-spacing: 0.12px;\n  }\n}\n@media (max-width: 290px) {\n  .infoContainer {\n    left: 8px;\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleRow": `HpErtGOAC8ijJpZZN9UR`,
	"infoThemeHot": `jsEBpyx_VN8vMD7AgNFf`,
	"infoThemeCold": `DlWN5H0rXvwLOpe1P5Jz`,
	"infoButton": `AlMyca9NXerFcGMpp3D1`,
	"infoContainer": `RhLavjo7yztWEqfGClI8`,
	"scaleIn": `a0OJuj9x3FE1cXZbPkBQ`,
	"closeButton": `hMRJaoB2BtYvhXReHoj_`,
	"infoText": `al5117oeQwui7nPoVz4t`
};
export default ___CSS_LOADER_EXPORT___;
